import React, {Component, createRef} from "react";
import * as R from "ramda";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import {Document, Page, pdfjs} from "react-pdf";
import ReactToPrint from "react-to-print";

// PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

class PaymentPrintPreview extends Component {
    constructor(props) {
        super(props);
        this.pdfContentRef = createRef();
        this.reactToPrintRef = createRef();
        this.state = { numPages: 0 };
    }

    handlePrint = () => {
        if (this.props.updatePrintCount){
            setTimeout(() => {
                this.reactToPrintRef.current.handlePrint();
            }, 300);
            this.props.updatePrintCount();
        }
    };

    render() {
        const { PDF, visible, onClickClose, onStateChange, title, paper, orientation } = this.props;
        const { numPages } = this.state;

        const paperSize = paper || "A5";
        const paperOrientation = orientation || (paperSize === "A5" ? "landscape" : "portrait");
        const sizes = {
            A5: { width: 559, height: 794 }, // 148 x 210 mm
            A4: { width: 794, height: 1123 }, // 210 x 297 mm
        };
        let {width, height} = sizes[paperSize] || sizes.A5;
        const baseWidth = width;
        if (paperOrientation === "landscape") {
            [width, height] = [height, width];
        }

        // const scale = window.devicePixelRatio || 1;
        const scale = (width / baseWidth) * 2;

        console.log("paper", paperSize, paperOrientation, width, height);
        console.log("scale", scale);

        const printStyles = `
            @media print {
                html, body {
                    margin: 0 !important;
                    padding: 0 !important;
                    height: 100% !important;
                    background: white !important;
                }
                
                @page {
                    size: ${paperSize} ${paperOrientation};
                    margin: 0;
                }

                .pdf-container {
                    display: flex !important;
                    justify-content: center !important;
                    align-items: flex-start !important;
                    width: 100% !important;
                    height: auto !important;
                    overflow: visible !important;
                    background: white !important;
                }

                canvas {
                    width: ${width}px !important;
                    height: auto !important;
                    max-height: ${height}px !important;
                    object-fit: contain !important;
                }
            }
        `;

        const screenStyles = {
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            width: "100%",
            background: "white",
        };

        return (
            <SimpleModal
                title={title}
                visible={visible}
                onClickClose={onClickClose}
                styles={{width: "100%"}}
                content={
                    <>
                        <style>{printStyles}</style>

                        <ReactToPrint
                            trigger={() => <div style={{ display: "none" }} />}
                            content={() => this.pdfContentRef.current}
                            ref={this.reactToPrintRef}
                        />

                        {!R.isNil(PDF) && (
                            <div ref={this.pdfContentRef} className="pdf-container" style={screenStyles}>
                                <Document
                                    file={PDF}
                                    onLoadSuccess={({ numPages }) => {
                                        this.setState({ numPages }, this.handlePrint);
                                    }}
                                >
                                    {Array.from({ length: numPages }, (_, index) => (
                                        <Page
                                            key={`page_${index + 1}`}
                                            pageNumber={index + 1}
                                            renderAnnotationLayer={false}
                                            renderTextLayer={false}
                                            // width={width}
                                            // height={height}
                                            scale={2.5}
                                        />
                                    ))}
                                </Document>
                            </div>
                        )}

                        <input
                            type="file"
                            accept=".pdf"
                            style={{ display: "none" }}
                            onChange={(e) => {
                                const file = e.target.files[0];
                                if (file?.type === "application/pdf") {
                                    const reader = new FileReader();
                                    reader.onload = () => {
                                        onStateChange({ PDF: reader.result });
                                    };
                                    reader.readAsDataURL(file);
                                }
                            }}
                        />
                    </>
                }
            />
        );
    }
}

export default PaymentPrintPreview;
